import { render, staticRenderFns } from "./priceArtisan.vue?vue&type=template&id=58f8065f&"
import script from "./priceArtisan.vue?vue&type=script&lang=js&"
export * from "./priceArtisan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports